import PropTypes from 'prop-types';
import React from 'react';

import './FormAutocompleteOption.scss';

class FormAutocompleteOption extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  constructor(props) {
    super(props);

    this.itemRef = React.createRef();
  }

  componentWillReceiveProps = newProps => {
    if (newProps.shouldFocus) {
      this.itemRef.current.focus();
    }
  };

  handleClick = () => {
    const { label, value } = this.props;
    this.props.onChange({ label, value });
  };

  handleFocus = () => {
    const { label, value } = this.props;
    this.props.onFocus({ label, value });
  };

  render() {
    const { label } = this.props;

    return (
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      <li
        className='Form__autocomplete__option'
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex='0'
        onClick={this.handleClick}
        onFocus={this.handleFocus}
        ref={this.itemRef}
      >
        {label}
      </li>
    );
  }
}

export default FormAutocompleteOption;
